import { PaymentScheduleActions } from 'actions/PaymentScheduleActions'
import { API_CALL_FAILURE, API_CALL_REQUEST, API_CALL_SUCCESS } from 'actions/actionConstants'
import { ADJUST_PAYMENT_SCHEDULE, FETCH_PAYMENT_SCHEDULE } from 'actions/apiActionConstants'
import { createReducer, reducerSwitch } from 'lib/redux/reducerUtils'

export const initialPaymentScheduleState: App.PaymentScheduleState = {
  fetchingCharges: {},
  charges: {},
  fetchingAdjustedCharges: {},
  adjustedCharges: {},
}

const apiRequests = reducerSwitch<App.PaymentScheduleState>({
  [FETCH_PAYMENT_SCHEDULE]: (state, action) => ({
    ...state,
    fetchingCharges: {
      ...state.fetchingCharges,
      [action.key]: true,
    },
  }),
  [ADJUST_PAYMENT_SCHEDULE]: (state, action) => ({
    ...state,
    fetchingAdjustedCharges: {
      ...state.fetchingAdjustedCharges,
      [action.key]: true,
    },
  }),
})

const apiSuccesses = reducerSwitch<App.PaymentScheduleState>({
  [FETCH_PAYMENT_SCHEDULE]: (state, action) => ({
    ...state,
    fetchingCharges: {
      ...state.fetchingCharges,
      [action.key]: false,
    },
    charges: {
      ...state.charges,
      [action.key]: {
        charges: action.data.charges,
        eligible: action.data.eligible,
      },
    },
  }),
  [ADJUST_PAYMENT_SCHEDULE]: (state, action) => ({
    ...state,
    fetchingAdjustedCharges: {
      ...state.fetchingAdjustedCharges,
      [action.key]: false,
    },
    adjustedCharges: {
      ...state.adjustedCharges,
      [action.key]: {
        charges: action.data.adjustedCharges,
        summary: action.data.adjustedSummary,
        eligible: action.data.eligible,
      },
    },
  }),
})

const apiFailures = reducerSwitch<App.PaymentScheduleState>({
  [FETCH_PAYMENT_SCHEDULE]: (state, action) => ({
    ...state,
    fetchingCharges: {
      ...state.fetchingCharges,
      [action.key]: false,
    },
  }),
  [ADJUST_PAYMENT_SCHEDULE]: (state, action) => ({
    ...state,
    fetchingAdjustedCharges: {
      ...state.fetchingAdjustedCharges,
      [action.key]: false,
    },
  }),
})

const paymentScheduleReducer = createReducer<App.PaymentScheduleState, PaymentScheduleActions>(initialPaymentScheduleState, {
  [API_CALL_REQUEST]: (state, action) => apiRequests(action.api)(state, action),
  [API_CALL_FAILURE]: (state, action) => apiFailures(action.api)(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiSuccesses(action.api)(state, action),
})

export default paymentScheduleReducer
